/**
 * Link Resolver
 */

export function linkResolver(type, uid) {
  if (type === null || uid === null) return undefined
  const queryPage = require(`../data/${type}/${uid}.json`)
  const url = queryPage.url
  return url
}

/**
 * Navigation Resolver
 */

export function navResolver(type, uid) {
  if (type === null || uid === null) return undefined
  const navigation = require(`../data/${type}/${uid}.json`)
  return navigation.data.navigation_items
}

/**
 * Entire element In Viewport
 * @param {DOMElement} el The DOM Element to query
 */

export function elementInViewport(el) {
  let rect = el.getBoundingClientRect()
  if (typeof window !== 'undefined') {
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /*or $(window).height() */ &&
      rect.right <=
        (window.innerWidth ||
          document.documentElement.clientWidth) /*or $(window).width() */
    )
  }
  return false
}

/**
 * Element Partially In Viewport
 * @param {DOMElement} el The DOM Element to query
 */

export function elementVisible(el, factorBot, factorTop) {
  let rect = el.getBoundingClientRect()
  let bottomFactor = factorBot || 1
  let topFactor = factorTop || 1

  if (typeof window !== 'undefined') {
    return rect.bottom >= 0
      ? rect.bottom <=
          (window.innerHeight * bottomFactor ||
            document.documentElement.clientHeight * bottomFactor) ||
          rect.top <=
            (window.innerHeight * topFactor ||
              document.documentElement.clientHeight * topFactor)
      : false
  }
}

/**
 * Calculate parallax transform
 * @param {DOMElement} el The DOM Element to query
 */

export function calcParallax(el, direction, value) {
  const rect = el.getBoundingClientRect()
  if (elementVisible(el)) {
    switch (direction) {
      case 'left':
        return `translate3d(-${value.x}px, 0, 0)`
      case 'right':
        return `translate3d(${value.x}px, 0, 0)`
      case 'up':
        return `translate3d(0, -${value.y}px, 0)`
      case 'down':
        return `translate3d(0, ${value.y}px, 0)`
      case 'auto':
      default:
        return `translate3d(${value.x ? `${value.x}px` : 0}, ${
          value.y ? `${value.y}px` : 0
        }, 0)`
    }
  }
}

/**
 * Device Assertion
 * Asserts the users device
 */

export function assertUserDevice() {
  if (typeof navigator !== `undefined`) {
    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPad/i)
    ) {
      return 'ios'
    } else if (navigator.userAgent.match(/Android/i)) {
      return 'android'
    }
  }
  return 'desktop'
}

/**
 * Viewport Assertion
 * Asserts the user Viewport
 */

export function assertViewport() {
  if (typeof window !== `undefined`) {
    const vp = document.body.clientWidth
    if (vp < 600) {
      return 'DEFAULT'
    } else if (vp < 1024) {
      return 'MEDIUM'
    } else if (vp < 1400) {
      return 'LARGE'
    } else {
      return 'MAXWIDTH'
    }
  }
}

/**
 * Make content renderable when no spans are available
 *
 */

export function makeContentRenderable(content) {
  return content
    .map(x => {
      if (x.type === 'embed' && !x.oembed) {
        return undefined
      }
      if (!x.spans) {
        return Object.assign({}, x, {
          spans: [],
        })
      }
      return x
    })
    .filter(Boolean)
}



// WEBPACK FOOTER //
// ./src/components/helper.jsx